// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardListAction.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  const { curry } = require('lodash/fp');
  var action = compose(
    withState('isGlobalExpand', 'updateGlobalExpand', true),
    withState('isLocalExpand', 'updateLocalExpand', true),
    withHandlers({
      toggle: curry(toggle)
    })
  );

  function toggle(props, isGlobal) {
    if (isGlobal) {
      props.updateGlobalExpand(!props.isGlobalExpand);
    } else {
      props.updateLocalExpand(!props.isLocalExpand);
    }
  }

  module.exports = action;
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardList/Izenda.DashboardListAction.js